import { recordMark } from '@stitch-fix/client-analytics-reporter';
import { sendLog } from '../../utils/sendMetrics';
import { useGetShopCategoriesQuery } from './getShopCategories';
import mockedResponse from './useShopCategoriesQuery.mockedResponse';

const useShopCategoriesQuery = ({
  businessLine,
  categoryId,
  gated,
  skip,
}: {
  businessLine: 'WOMENS' | 'MENS' | 'KIDS' | 'SHELL' | null;
  categoryId?: string | null;
  skip: boolean;
  gated?: boolean;
}) => {
  const {
    data: shopCategoriesData,
    loading: shopCategoriesLoading,
    error: shopCategoriesError,
  } = useGetShopCategoriesQuery({
    skip,
    variables: {
      /*
       We only want to pass in businessLine for categories in ungated.
       Categories are set up on the backend in a way where if we pass in
       businessLine, it will automatically assume we want ungated categories
       rather than personalized categories.
      */
      businessLine: gated ? null : businessLine,
      categoryId,
    },
    onCompleted: () => {
      recordMark('use_shop_categories_query_completed', {
        graph_query_succeeded: true,
      });
    },
    onError: () => {
      recordMark('use_shop_categories_query_completed', {
        graph_query_succeeded: false,
      });

      sendLog(
        `useGetShopCategoriesQuery error for business line ${businessLine} and category ID ${categoryId}: ${shopCategoriesError}`,
        {
          businessLine,
          categoryId,
          error_message: shopCategoriesError,
        },
      );
    },
  });

  /* @ts-ignore no type for window */
  if (window.gon.use_mock_graphql_data) {
    return {
      shopCategoriesData: mockedResponse.data,
      shopCategoriesLoading,
      shopCategoriesError,
    };
  }

  return {
    shopCategoriesData,
    shopCategoriesLoading,
    shopCategoriesError,
  };
};

export default useShopCategoriesQuery;
